import {Component, Input} from '@angular/core';


@Component({
    selector: 'app-control-index-card',
    templateUrl: './control-index-card.component.html',
    styleUrls: ['./control-index-card.component.scss'],
    standalone: false
})
export class ControlIndexCardComponent {
  @Input() public title;
  @Input() public description;
  @Input() public url;
  @Input() public count = null;
  @Input() public loading = false;
  @Input() public isWarning = false;

  constructor() {
  }

}
